module.exports = __webpack_public_path__ + "static/media/industries-recycling-s.f744975f.jpg";